import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { CampaignState } from './types';

// export interface GettersType {}

export const getters: GetterTree<CampaignState, RootState> /*& GettersType*/ = {

};
